import { render, staticRenderFns } from "./evidencias.vue?vue&type=template&id=a579733e&scoped=true&"
import script from "./evidencias.vue?vue&type=script&lang=js&"
export * from "./evidencias.vue?vue&type=script&lang=js&"
import style0 from "./evidencias.vue?vue&type=style&index=0&id=a579733e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a579733e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VLabel,VSpacer,VTextField})
